import * as eventTypes from '../../../../js/document/event-types'
import { accommodationSkiBlockMapper } from '../mappers/accommodation-ski-block/accommodation-ski-block-mapper'
import pusher from '../pusher'

export function listenCollapseEvents (event, track) {
  event.on(eventTypes.collapseEvents.OPEN, (data) => {
    const mappedData = accommodationSkiBlockMapper(data, eventTypes.collapseEvents.OPEN, track)
    pusher.pushDataObject(mappedData)
  })

  event.on(eventTypes.collapseEvents.CLOSE, (data) => {
    const mappedData = accommodationSkiBlockMapper(data, eventTypes.collapseEvents.CLOSE, track)
    pusher.pushDataObject(mappedData)
  })
}
